<template>
  <CancelFlowRedesignExperiment>
    <template #default>
      <AccountMembership/>
    </template>
    <template #redesign>
      <AccountMembershipRedesign/>
    </template>
  </CancelFlowRedesignExperiment>
</template>

<script setup>
import CancelFlowRedesignExperiment from '@/components/account/membership/new/CancelFlowRedesignExperiment.vue'
import AccountMembership from '@/components/account/membership/AccountMembership.vue'
import AccountMembershipRedesign from '@/views/account/AccountMembership.vue'
</script>
